import React, { useState, useEffect, useMemo } from 'react';
import {
  ArrowRight, PlusCircle, MinusCircle, Download,
  Landmark, Wallet, Percent, FileText, ChevronRight,
  PiggyBank, BriefcaseBusiness,
  BadgeDollarSign, Upload, DownloadCloud,
  HandCoins, Filter, ChevronLeft,
  Database,
  PieChart,
  Calendar,
  CirclePercent, X
} from 'lucide-react';
import { FaEye } from "react-icons/fa";


import styles from './Deductions.module.css';
import Sidebar2 from '../../Components/SideBar2/SideBar2';
import Header2 from '../../Components/Header2/Header2';
import axios from 'axios';
import { BASE_URL } from '../../Components/Api/Api';
import { Form, Placeholder, Modal, Button, Table } from "react-bootstrap";
import Select from "react-select";
import Swal from "sweetalert2";

import {
  FiX,
  FiPhone,
  FiMail,
  FiGlobe,
  FiDownload,
  FiPrinter
} from "react-icons/fi";

// import logo from "../../assets/logo.png";




 

  const formatMoney = (amount) => {
    return Number(amount || 0).toLocaleString("en-NG", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const handlePrint = () => {
    window.print();
  };

  const handleDownloadPDF = () => {
    // Will implement later
    console.log("Download PDF");
  };

  

const tableColumnCount = 8; // S/N, Reference No, Description, Transaction Date, Type, Debit, Credit, Balance

export default function Deductions() {

  
    const currentDate = useMemo(() => {
    return new Date().toLocaleString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }, []);

      const member = {
        name: "John Adewale",
        memberId: "RWF/RC12345",
        department: "Finance Department",
        membershipType: "Regular Member",
        employmentType: "Full Time",
        phone: "+234 801 234 5678",
    };

    const deductions = [
        {
            description: "Regular Savings",
            amount: 5000,
        },
        {
            description: "Share Contribution",
            amount: 10000,
        },
        {
            description: "Loan Repayment (LN-2024-0012)",
            amount: 15000,
        },
        {
            description: "Welfare Fund",
            amount: 2000,
        },
        {
            description: "Administrative Charge",
            amount: 1000,
        },
    ];




  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [loading, setLoading] = useState(true);       // table loading
  const [show, setShow] = useState(false);       // table loading
  const [statsLoading, setStatsLoading] = useState(true); // cards loading

  const [ledgers, setLedgers] = useState([]);          // full dataset for the currently selected loan
  const [displayedLedgers, setDisplayedLedgers] = useState([]); // dataset after the date filter is applied
  const [stats, setStats] = useState({});

  const [savings, setSavings] = useState([]);
  const [savingsType, setSavingsType] = useState(null);
  const [selectedDate, setSelectedDate] = useState("");

   const totalDeduction = displayedLedgers.reduce(
    (sum, item) => sum + Number(item.amount || 0),
    0
  );

const CardSkeleton = () => (
  <div className={styles.statCard}>
    {/* Icon */}
    <Placeholder
      as="div"
      animation="glow"
      style={{
        width: 36,
        height: 36,
        borderRadius: 8,
        display: "flex",
      }}
    >
      <Placeholder
        xs={12}
        style={{
          width: "100%",
          height: "100%",
          borderRadius: 8,
        }}
      />
    </Placeholder>

    <div className={styles.statContent} style={{ width: "100%" }}>
      <Placeholder animation="glow">
        <Placeholder
          xs={5}
          style={{
            display: "block",
            height: 12,
            marginBottom: 8,
            borderRadius: 4,
          }}
        />

        <Placeholder
          xs={7}
          style={{
            display: "block",
            height: 22,
            marginBottom: 18,
            borderRadius: 4,
          }}
        />

        <Placeholder
          xs={4}
          style={{
            display: "block",
            height: 10,
            marginTop: 10,
            borderRadius: 4,
          }}
        />
      </Placeholder>
    </div>
  </div>
);

const formatCurrency = (value) => `₦${Number(value || 0).toLocaleString('en-NG')}`;
  const formatCurrencys = (value) =>
    Number(value ?? 0).toLocaleString("en-NG", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    
const formatMetricValue = (value, type = "number") => {
  const numericValue = Number(value);

  // Handle invalid values
  if (
    value === null ||
    value === undefined ||
    value === "" ||
    Number.isNaN(numericValue)
  ) {
    return type === "currency" ? "₦0.00" : "0";
  }

  // Percent
  if (type === "percent") {
    return `${numericValue.toFixed(0)}%`;
  }

  // Currency
  if (type === "currency") {
    const absValue = Math.abs(numericValue);
    const sign = numericValue < 0 ? "-" : "";

    let formatted;

    if (absValue >= 1_000_000_000_000) {
      formatted = `${(absValue / 1_000_000_000_000)
        .toFixed(1)
        .replace(/\.0$/, "")}T`;
    } else if (absValue >= 1_000_000_000) {
      formatted = `${(absValue / 1_000_000_000)
        .toFixed(1)
        .replace(/\.0$/, "")}B`;
    } else if (absValue >= 1_000_000) {
      formatted = `${(absValue / 1_000_000)
        .toFixed(1)
        .replace(/\.0$/, "")}M`;
    } else if (absValue >= 1_000) {
      formatted = `${(absValue / 1_000)
        .toFixed(1)
        .replace(/\.0$/, "")}K`;
    } else {
      formatted = absValue.toLocaleString("en-NG", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }

    return `${sign}₦${formatted}`;
  }

  // Normal numbers
  if (Number.isInteger(numericValue)) {
    return numericValue.toLocaleString("en-NG");
  }

  return numericValue.toLocaleString("en-NG", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

  // ---- data fetching ----
  const fetchLedger = async (loanId = null) => {
    setLoading(true);
    setStatsLoading(true);

    try {
      const token = localStorage.getItem("token");
      const companyid = localStorage.getItem("companyId");
    //  const companyid = localStorage.getItem("companyId");
      const memberid = localStorage.getItem("memberId");

      let url = `${BASE_URL}`;
      if (loanId) {
        url += `&loan_id=${loanId}`;
      }

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const data = res.data?.data || {};
      const ledgerData = data.ledger || [];

      setLedgers(ledgerData);
      setStats(data.summary || {});
      setCurrentPage(1);

      // Keep whatever date filter is currently active applied to the freshly fetched data
      if (selectedDate) {
        setDisplayedLedgers(
          ledgerData.filter((item) => item.transaction_date === selectedDate)
        );
      } else {
        setDisplayedLedgers(ledgerData);
      }
    } catch (error) {
      console.error(error);
      setLedgers([]);
      setDisplayedLedgers([]);
      setStats({});
    } finally {
      setLoading(false);
      setStatsLoading(false);
    }
  };

  const fetchInvoices = async () => {
    try {
      const token = localStorage.getItem("token");
      const companyid = localStorage.getItem("companyId");
      const memberid = localStorage.getItem("memberId");

      const res = await axios.get(
        `${BASE_URL}/member-auth/member_loan_plans?company_id=${companyid}&member_id=${memberid}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      const savingsData = res.data?.data || [];
      setSavings(savingsData);
    } catch (error) {
      console.error(error);
      setSavings([]);
    }
  };

  useEffect(() => {
    fetchLedger();      // default load — no loan_id
    fetchInvoices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const savingsOptions = savings.map((item) => ({
  //   value: item.loan?.id,
  //   label: item.loan?.loan_name || item.type?.product_name,
  //   ...item.type,
  // }));

  const selectStyles = {
    control: (base) => ({
      ...base,
      borderRadius: "10px",
      fontSize: "12px",
      minHeight: 40,
      height: "auto",
    }),
    valueContainer: (base) => ({
      ...base,
      height: 40,
      padding: "0 8px",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: 40,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#15803d"
        : state.isFocused
        ? "#EBFFF3"
        : "transparent",
      color: state.isSelected ? "#fff" : "inherit",
      fontSize: "12px",
      cursor: "pointer",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#6c757d",
      fontSize: "12px",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "12px",
      color: "#212529",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "0.375rem",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      zIndex: 9999,
    }),
  };

  // ---- filter handlers ----
  const handleSavingsTypeChange = (selected) => {
    setSavingsType(selected);
    fetchLedger(selected?.value || null); // now sent as loan_id
  };

  const handleRemoveFilter = () => {
    setSavingsType(null);
    fetchLedger(null);
  };

  const handleDateChange = (e) => {
    const date = e.target.value;
    setSelectedDate(date);
    setCurrentPage(1);

    if (date) {
      setDisplayedLedgers(
        ledgers.filter((item) => item.transaction_date === date)
      );
    } else {
      setDisplayedLedgers(ledgers);
    }
  };

  // ---- pagination (driven by the actual API data) ----
  const totalItems = displayedLedgers.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentTransactions = displayedLedgers.slice(startIndex, endIndex);

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  // ---- stat cards, built from live `stats` state ----
  const loanStats = [
    {
      id: 'owed',
      label: 'Total Deductions',
      // value: `₦${formatCurrencys(stats.total_loan_owe)}`,
      value: formatMetricValue(stats.total_loan_owe, "currency"),
      detail: 'Deductions from account.',
      bgColor: '#eaf8ef',
      textColor: '#059447',
      icon: <Wallet size={22} color="#059447" />,
    },
    {
      id: 'repayment',
      label: 'Savings Contributions',
      // value: `₦${formatCurrencys(stats.total_loan_repayment)}`,
      value: formatMetricValue(stats.total_loan_repayment, "currency"),
      detail: 'Deduction towards a target.',
      bgColor: '#dbeafe',
      textColor: '#0284c7',
      icon: <Database size={22} color="#0284c7" />,
    },
    {
      id: 'balance',
      label: 'Loan Repayments',
      value: formatMetricValue(stats.loan_balance, "currency"),
      detail: 'Repayments deduction.',
      bgColor: '#fee2e2',
      textColor: '#dc2626',
      icon: <PieChart size={22} color="#f59e0b" />,
    },
    {
      id: 'currentMonth',
      label: 'Upcoming Deductions',
      value: formatMetricValue(stats.current_month_repayment, "currency"),
      detail: 'Scheduled deductions.',
      bgColor: '#f3e8ff',
      textColor: '#a855f7',
      icon: <Calendar size={22} color="#9333ea" />,
    },
  ];

  const handleClose = () => setShow(false);
    const handleShow = () =>{ 

        if (!ledgers || ledgers.length === 0) {
              Swal.fire({
                  title: "No Data Available",
                  text: "Cannot print or generate slip due to absence of data.",
                  icon: "warning",
                  confirmButtonText: "OK",
                  confirmButtonColor: "#15803d", // Green matching your theme
                  heightAuto: false,
              });
              return; // Stop navigation
          }


      setShow(true)
    };

    const memberNumber = localStorage.getItem('memberPhoneNumber');
const memberAddress = localStorage.getItem('memberAddress');
const memberName = localStorage.getItem('memberName');
const department = localStorage.getItem('department');
const saveType = localStorage.getItem('saveType');
const emplyoerName = localStorage.getItem('employerName');

  return (
    <div className={styles.container}>
      <Sidebar2 active="deductions" />


        <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      dialogClassName={styles.modalWidth}
    >
      {/* ========================= HEADER ========================= */}

      <Modal.Header className={styles.modalHeader}>

        <Modal.Title className={styles.title}>
          Member Deduction Slip
        </Modal.Title>

        <button
          className={styles.closeButton}
          onClick={handleClose}
        >
          <FiX />
        </button>

      </Modal.Header>

      {/* ========================= BODY ========================= */}

      <Modal.Body className={styles.modalBody}>

        <div className={styles.slipContainer}>

          {/* ========================= COMPANY HEADER ========================= */}

          <div className={styles.companyHeader}>

            <div className={styles.companyLeft}>

              {/* <img
                  src={logo}
                  alt="Logo"
                  className={styles.logo}
              /> */}

              <div>

                <h2 className={styles.companyName}>
                  RCCG WORKERS FUND COOPERATIVE
                </h2>

                <p className={styles.tagline}>
                  Faith. Unity. Progress.
                </p>

                

              </div>

            </div>

            <div className={styles.companyRight}>

              <p className={styles.generatedLabel}>
                Date Generated:
              </p>

              <p className={styles.generatedDate}>
                {currentDate}
              </p>

            </div>

          </div>

           {/* <div className={styles.contactRow}>

                  <div className={styles.contactItem}>
                    <FiPhone />
                    <span>+234 700 123 4567</span>
                  </div>

                  <div className={styles.contactItem}>
                    <FiMail />
                    <span>info@rccgworkersfundcoop.org</span>
                  </div>

                  <div className={styles.contactItem}>
                    <FiGlobe />
                    <span>www.rccgworkersfundcoop.org</span>
                  </div>

                </div> */}

          {/* ========================= MEMBER INFORMATION ========================= */}

          <div className={styles.memberCard}>

            <h5 className={styles.sectionTitle}>
              Member Information
            </h5>

          <div className={styles.memberGrid}>
  <div className={styles.infoColumn}>
    <div className={styles.infoRow}>
      <span className={styles.label}>Member Name:</span>
      <span className={styles.value}>
        {memberName && memberName !== "null" ? memberName : ""}
      </span>
    </div>
    
    <div className={styles.infoRow}>
      <span className={styles.label}>Member ID:</span>
      <span className={styles.value}>
        {memberNumber && memberNumber !== "null" ? memberNumber : ""}
      </span>
    </div>
    
    <div className={styles.infoRow}>
      <span className={styles.label}>Department:</span>
      <span className={styles.value}>
        {department && department !== "null" ? department : ""}
      </span>
    </div>
  </div>

  <div className={styles.infoColumn}>
    <div className={styles.infoRow}>
      <span className={styles.label}>Employee Name:</span>
      <span className={styles.value}>
        {emplyoerName && emplyoerName !== "null" ? emplyoerName : ""}
      </span>
    </div>
    
    <div className={styles.infoRow}>
      <span className={styles.label}>Savings Type:</span>
      <span className={styles.value}>
        {saveType && saveType !== "null" ? saveType : ""}
      </span>
    </div>
    
    <div className={styles.infoRow}>
      <span className={styles.label}>Phone Number:</span>
      <span className={styles.value}>
        {/* Note: Check if phone should use a separate variable like 'phoneNumber' instead of 'memberNumber' */}
        {memberNumber && memberNumber !== "null" ? memberNumber : ""}
      </span>
    </div>
  </div>
</div>


          </div>

          {/* ========================= DEDUCTION DETAILS ========================= */}

          <div className={styles.deductionSection}>

            <h5 className={styles.sectionTitle}>
              Deduction Details
            </h5>

            <div className={styles.tableWrappers}>

              <table
                className={styles.tables}
              >

                <thead>

                  <tr>

                    <th style={{ width: "80px" }}>
                      S/N
                    </th>

                    <th>
                      Description
                    </th>

                    {/* <th
                      style={{
                        width: "180px",
                        textAlign: "right",
                      }}
                    >
                      Debit (₦)
                    </th> */}
                    {/* <th
                      style={{
                        width: "180px",
                        textAlign: "right",
                      }}
                    >
                      Credit (₦)
                    </th> */}
                    {/* <th
                      style={{
                        width: "180px",
                        textAlign: "right",
                      }}
                    >
                      Balance (₦)
                    </th> */}
                    <th
                      style={{
                        width: "180px",
                        textAlign: "right",
                      }}
                    >
                      Amount (₦)
                    </th>

                  </tr>

                </thead>

                <tbody>
                  {ledgers.length > 0 ? (
                    ledgers.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.description}</td>
                        {/* <td className={styles.amountCell}>
                          {formatMoney(item.debit)}
                        </td> */}
                        {/* <td className={styles.amountCell}>
                          {formatMoney(item.credit)}
                        </td> */}
                        <td className={styles.amountCell}>
                          {formatMoney(item.balance)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" style={{ textAlign: 'center' }}>No ledger data available.</td>
                    </tr>
                  )}
                </tbody>


              </table>

            </div>

          </div>

          {/* ========================= TOTAL ========================= */}

          <div className={styles.totalCard}>

            <span>Total Deduction</span>

            <span className={styles.totalAmount}>
              ₦
              {formatMoney(
                displayedLedgers.length
                  ? totalDeduction
                  : 33000
              )}
            </span>

          </div>

        </div>

      </Modal.Body>

      {/* ========================= FOOTER ========================= */}

      <Modal.Footer className={styles.footer}>

        <div className={styles.footerText}>
          This is a system generated slip and does not require a signature.
        </div>

        <div className={styles.footerButtons}>

          <Button
            // variant="light"
            className={styles.downloadBtn}
            // onClick={handleDownloadPDF}
          >
            <FiDownload />
            <span>Download</span>
          </Button>

          <Button
            // variant="light"
            className={styles.printBtn}
            // onClick={handlePrint}
          >
            <FiPrinter />
            <span>Print</span>
          </Button>

          <Button
            className={styles.closeBtn}
            onClick={handleClose}
          >
            Close
          </Button>

        </div>

      </Modal.Footer>

    </Modal>


      <main className={styles.mainContent}>
        <Header2 title="My Deductions" />

        <div className={styles.workspace}>
          {/* Stats Cards */}
          <div className={styles.statsGrid}>
            {statsLoading
              ? Array.from({ length: 4 }).map((_, idx) => (
                   <CardSkeleton key={idx} />
                ))
              : loanStats.map((stat) => (
                  <div key={stat.id} className={styles.statCard}>
                    <div className={styles.statIcon} style={{ backgroundColor: stat.bgColor }}>
                      {stat.icon}
                    </div>
                    <div className={styles.statContent}>
                      <p className={styles.statLabel}>{stat.label}</p>
                      <h3 className={styles.statValue} style={{ color: stat.textColor }}>
                        {stat.value}
                      </h3>
                      <p className={styles.statDetail}>{stat.detail}</p>
                    </div>
                  </div>
                ))}
          </div>

          {/* Transaction Ledger Section */}
          <div className={styles.ledgerSection}>
            <div className={styles.ledgerHeader}>
              <div>
                <h2>Deduction Slip</h2>
                <p>Detailed view of all your deductions.</p>
              </div>

              <div className={styles.ledgerControls}>
                {/* <Select
                  options={savingsOptions}
                  value={savingsType}
                  onChange={handleSavingsTypeChange}
                  placeholder="Select Loan Type"
                  isLoading={loading}
                  styles={selectStyles}
                />

                {savingsType && (
                  <button
                    type="button"
                    className={styles.exportBtn}
                    onClick={handleRemoveFilter}
                    title="Clear filter"
                  >
                    <X size={16} />
                    Clear
                  </button>
                )} */}

                <div className={styles.dateRange}>
                  <Form.Control
                    type="date"
                    value={selectedDate}
                    onChange={handleDateChange}
                  />
                </div>

                <button className={styles.exportBtn} type="button"
                // onClick={handleShow}
                >
                  <Download size={16} />
                  Print Slip
                </button>
              </div>
            </div>

            {/* Table */}
            <div className={styles.tableWrapper}>
              <table className={styles.transactionTable}>
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>Reference No.</th>
                    <th>Description</th>
                    <th>Transaction Date</th>
                    <th>Type</th>
                    <th style={{ textAlign: 'right' }}>Debit</th>
                    <th style={{ textAlign: 'right' }}>Credit</th>
                    <th style={{ textAlign: 'right' }}>Balance</th>
                    <th style={{ textAlign: 'right' }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    Array.from({ length: 6 }).map((_, rowIdx) => (
                      <tr key={`skeleton-${rowIdx}`}>
                        {Array.from({ length: tableColumnCount }).map((__, colIdx) => (
                          <td key={colIdx}>
                            <Placeholder as="span" animation="glow">
                              <Placeholder xs={colIdx === 0 ? 4 : 8} />
                            </Placeholder>
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : currentTransactions.length === 0 ? (
                    <tr>
                      <td colSpan={tableColumnCount} style={{ textAlign: 'center', padding: '24px' }}>
                        No transactions found.
                      </td>
                    </tr>
                  ) : (
                    currentTransactions.map((item, index) => {
                      const statusNum = Number(item.status);
                      const isDisbursement = statusNum === 1;
                      const typeLabel = isDisbursement ? 'Disbursement' : statusNum === 2 ? 'Repayment' : '—';
                      const typeColor = isDisbursement ? '#16a34a' : '#dc2626';

                      return (
                        <tr key={item.id}>
                          <td>{startIndex + index + 1}</td>
                          <td>{item.uuid}</td>
                          <td style={{ width: "25%", maxWidth: "25%" }}>{item.description}</td>
                          <td className={styles.dateCell}>{item.transaction_date}</td>
                          <td>
                            <span
                              className={styles.typeTag}
                              style={{
                                color: typeColor,
                                backgroundColor: `${typeColor}15`,
                              }}
                            >
                              {typeLabel}
                            </span>
                          </td>
                          <td style={{ textAlign: 'right' }}>{formatCurrencys(item.debit)}</td>
                          <td style={{ textAlign: 'right' }}>{formatCurrencys(item.credit)}</td>
                          <td style={{ textAlign: 'right' }}>{formatCurrencys(item.balance)}</td>
                          <td>
                          {/* {formatCurrencys(item.balance)} */}
                            <div style={{cursor: "pointer"}} onClick={handleShow}>
                              <FaEye style={{color:  "#65c789"}} size={14} />
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className={styles.paginationContainer}>
              <p className={styles.paginationInfo}>
                {totalItems === 0
                  ? 'Showing 0 of 0 transactions'
                  : `Showing ${startIndex + 1} to ${Math.min(endIndex, totalItems)} of ${totalItems} transactions`}
              </p>

              <div className={styles.paginationControls}>
                <button
                  type="button"
                  className={styles.paginationBtn}
                  onClick={() => goToPage(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  <ChevronLeft size={16} />
                </button>

                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <button
                    key={page}
                    type="button"
                    className={`${styles.paginationBtn} ${
                      page === currentPage ? styles.activePage : ''
                    }`}
                    onClick={() => goToPage(page)}
                  >
                    {page}
                  </button>
                ))}

                <button
                  type="button"
                  className={styles.paginationBtn}
                  onClick={() => goToPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  <ChevronRight size={16} />
                </button>
              </div>

              <div className={styles.itemsPerPage}>
                <select value={itemsPerPage} onChange={handleItemsPerPageChange}>
                  <option value={10}>10 / page</option>
                  <option value={20}>20 / page</option>
                  <option value={50}>50 / page</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
